var map = {
	"./favicon.png": 946,
	"./helsinki-min.png": 9860,
	"./kaypyla-min.png": 8829,
	"./kilo-min.png": 8736,
	"./lahti-min.png": 4481,
	"./logo-icons.svg": 1276,
	"./socialMedia-icons.svg": 9903,
	"./tampere-min.png": 5736,
	"./turku-min.png": 8654
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;